<ng-container [ngSwitch]="remoteConfigStore.typeOfBookingPackage$ | async">
  <app-booking-overview-commercial
    *ngSwitchCase="BookingSubscriptionPackageOptions.Commercial"
  ></app-booking-overview-commercial>
  <app-booking-overview-flat-rate
    *ngSwitchCase="BookingSubscriptionPackageOptions.FlatRate"
  ></app-booking-overview-flat-rate>
  <app-booking-overview-voucher *ngSwitchCase="BookingSubscriptionPackageOptions.UserUsaCanada">
  </app-booking-overview-voucher>
  <app-booking-overview-subscription-per-installation
    *ngSwitchDefault
  ></app-booking-overview-subscription-per-installation>
</ng-container>
